import React, { useEffect, useState } from "react";
import './mainpage.css';
import AOS from 'aos';
import 'aos/dist/aos.css';
//import Blog from '.pages/blog';
function Mainpage() {
     useEffect(() => {
    AOS.init({
      duration: 1000, // animation duration in ms
      offset: 100, // offset (in px) from the original trigger point
      easing: "ease-in-out", // easing function
      once: true, // animation happens only once
    });
    AOS.refresh();
  }, []);
  return (
    
    <div>
        <div className="banner-img">
           <p className="display-4 text-center fw-bold text-white">Powerful Web Hosting Services</p>
           <p className="fs-4 text-center text-white">Create, collaborate, and turn your ideas into incredible products with the definitive platform for digital design.</p>
        </div>
        <div className="container top-30">
            <div className="row">
                <div className="col-md-4" data-aos="fade-up" data-aos-delay="100">
                    <div className="bg-white rounded-5 shadow pb-5 text-center">
                        <p className="fs-3 fw-bold text-center pt-5">VPS Hosting</p><hr/>
                        <p className="display-3 color pt-3">$6.88<span className="fs-5">/mo</span></p>
                        <p className="fs-5 mb-0">2 CPU cores</p>
                        <p className="fs-5 mb-0">2 GB RAM</p>
                        <p className="fs-5 mb-0">40 GB SSD RAID 10</p>
                        <p className="fs-5 mb-0">1000 GB bandwidth</p>
                        <button type="submit" class="insuba-btn text-center p-2 fs-5 mt-5"><a href="Contactform" className='p-5'>Contact Us</a></button>
                    </div>
                  
                </div>
                <div className="col-md-4" data-aos="fade-up" data-aos-delay="300">
                    <div className="bg-white rounded-5 shadow pb-5 text-center">
                        <p className="fs-3 fw-bold text-center pt-5">Cloud Hosting</p><hr/>
                        <p className="display-3 color pt-3">$11.99<span className="fs-5">/mo</span></p>
                        <p className="fs-5 mb-0">2 CPU cores</p>
                        <p className="fs-5 mb-0">2 GB RAM</p>
                        <p className="fs-5 mb-0">SSD Disk-Space: Unmetered</p>
                        <p className="fs-5 mb-0">Bandwidth: Unmetered</p>
                        <button type="submit" class="insuba-btn text-center p-2 fs-5 mt-5"><a href="Contactform" className='p-5'>Contact Us</a></button>
                    </div>
                </div>
                <div className="col-md-4" data-aos="fade-up" data-aos-delay="500">
                    <div className="bg-white rounded-5 shadow pb-5 text-center">
                        <p className="fs-3 fw-bold text-center pt-5">Linux Hosting</p><hr/>
                        <p className="display-3 color pt-3">$1.49<span className="fs-5">/mo</span></p>
                        <p className="fs-5 mb-0">Disk Space: 5 GB</p>
                        <p className="fs-5 mb-0">MySQL DB: 5</p>
                        <p className="fs-5 mb-0">Security: Imunify360</p>
                        <p className="fs-5 mb-0">Bandwidth: Unlimited</p>
                        <button type="submit" class="insuba-btn text-center p-2 fs-5 mt-5"><a href="Contactform" className='p-5'>Contact Us</a></button>
                    </div>
                </div>
            </div>
        </div>
        <div className='container mt-5 pt-5'>
            <div className='row mt-5 mb-5'>
                <div className="col-md-6" data-aos="fade-up" data-aos-delay="100">
                     <div className="bg-white shadow pb-5">
                        <div className='row p-5'>
                            <div className='col-md-4'>
                                <img src="https://www.interserver.net/assets/images/new/icons/asp.svg" className='w-100 p-3' />
                                <p className="fs-1 fw-bold ">$8.00 <span className="fs-5 color">/mo</span></p>
                            </div>
                            <div className='col-md-8'>
                                <p className="fs-5">Easy to use Control Panel Speed Optimization Unlimited Storage Space Free Website Migration Unlimited Support</p>
                                <button type="submit" class="insuba-btn text-center p-2 fs-5 mt-5"><a href="Contactform" className='p-5'>Select Plan</a></button>
                            </div>
                        </div>
                    </div>
                 </div>
                <div className="col-md-6" data-aos="fade-up" data-aos-delay="100">
                     <div className="bg-white shadow pb-5">
                        <div className='row p-5'>
                            <div className='col-md-4'>
                                <img src="https://www.interserver.net/assets/images/new/icons/vps-special.svg" className='w-100 p-3' />
                                <p className="fs-1 fw-bold">$3.00<span className="fs-5 color">/Mo</span></p>
                            </div>
                            <div className='col-md-8'>
                                <p className="fs-5">2GB RAM + 30GB SSD Storage Multiple Operating Systems Instant Activation cPanel or Direct Admin Unlimited Support </p>
                                <button type="submit" class="insuba-btn text-center p-2 fs-5 mt-5"><a href="Contactform" className='p-5'>Select Plan</a></button>
                            </div>
                        </div>
                     </div>
                </div>
            </div>
             <p className="display-4 p-5 mb-0 pb-0 fw-bold text-center color">Powerful Features</p>
            <p className="fs-6 text-center">All-In Web hosting includes everything you need to get your website online.</p>
            <div className='row mt-5 mb-5'>
                <div className="col-md-4 text-center p-5 shadow" data-aos="fade-up" data-aos-delay="100">
                    <img src="https://www.interserver.net/assets/images/new/icons/features/guarantee.svg" className='icons pb-5' />
                    <p className="fs-3 fw-bold ">30 Day Guarantee</p>
                    <p className="fs-6">If you are not fully satisfied with our web hosting plans, we will issue a refund</p>
                </div>
                <div className="col-md-4 text-center p-5 shadow" data-aos="fade-up" data-aos-delay="100">
                    <img src="https://www.interserver.net/assets/images/new/icons/features/migrations.svg" className='icons pb-5' />
                    <p className="fs-3 fw-bold ">70% Are Migrations</p>
                    <p className="fs-6">A majority of our customers have migrated from other hosts.</p>
                </div>
                <div className="col-md-4 text-center p-5 shadow" data-aos="fade-up" data-aos-delay="100">
                    <img src="https://www.interserver.net/assets/images/new/icons/features/fast.svg" className='icons pb-5' />
                    <p className="fs-3 fw-bold ">Ultra-Fast Speeds!</p>
                    <p className="fs-6">Your website will load faster than ever because our servers are never overloaded. The network is route optimized. We also run the latest server optimization and security technology.</p>
                </div>
            </div>
            <div className='row mt-5 mb-5'>
                <div className="col-md-4 text-center p-5 shadow" data-aos="fade-up" data-aos-delay="100">
                    <img src="https://www.interserver.net/assets/images/new/icons/features/renewal-cost.svg" className='icons pb-5' />
                    <p className="fs-3 fw-bold ">Renewal Cost</p>
                    <p className="fs-6">While our competitors have high renewal rates, InterServer does not!</p>
                </div>
                <div className="col-md-4 text-center p-5 shadow" data-aos="fade-up" data-aos-delay="100">
                    <img src="https://www.interserver.net/assets/images/new/icons/features/uptime.svg" className='icons pb-5' />
                    <p className="fs-3 fw-bold ">99.9% Uptime</p>
                    <p className="fs-6">Industry-leading reliability of service and content delivery. We partner with Cloudflare and utilize its global network of caching data center.</p>
                </div>
                <div className="col-md-4 text-center p-5 shadow" data-aos="fade-up" data-aos-delay="100">
                    <img src="https://www.interserver.net/assets/images/new/icons/features/support.svg" className='icons pb-5' />
                    <p className="fs-3 fw-bold ">24/7 Support</p>
                    <p className="fs-6">Our dedicated support team is available around the clock to help with any issues you may encounter. You can reach us by Phone, Live Chat, or Ticket System.</p>
                </div>
            </div>
            <p className="display-4 p-5 fw-bold text-center color">Choose Your Best Plans</p>
            <div className="row">
                <div className="col-md-3 text-center pb-5" data-aos="fade-up" data-aos-delay="100">
                     <div className="bg-white shadow pb-5 text-center">
                        <p className="bg-color text-white fs-3 p-5 text-center">Basic Plan</p>
                        <p className="display-3 color pt-5">$2.95<span className="fs-5">/mo</span></p>
                        <p className="fs-3 pb-3">Host 1 Website <br/><span className="fs-6">Unlimited Domain Pointers</span></p>
                        <div className="fs-6 space">
                            <p className="fs-5 mb-0"> Unlimited Space/Transfers </p>
                            SQL Server 2022/MySQL<br />
                            .NET 10 Hosting<br />
                            ASP.NET Core 10/Node.js<br />
                            ASP.NET 4.8/ASP/PHP 8.x  
                            <br />Free 256 bit SSL 
                        </div>
                        <button type="submit" class="insuba-btn text-center p-2 fs-5 mt-5"><a href="Contactform" className='p-5'>Contact Us</a></button>
                    </div>
                </div>
                <div className="col-md-3 text-center  pb-5" data-aos="fade-up" data-aos-delay="300">
                     <div className="bg-white shadow pb-5 text-center">
                        <p className="bg-color text-white fs-3 text-center p-5">Advance Plan</p>
                        <p className="display-3 color pt-5">$4.95<span className="fs-5">/mo</span></p>
                        <p className="fs-3 pb-3">Host 6 Website <br/><span className="fs-6">Unlimited Domain Pointers</span></p>
                        <div className="fs-6 space">
                            <p className="fs-5 mb-0"> Unlimited Space/Transfers </p>
                            SQL Server 2022/MySQL<br />
                            .NET 10 Hosting<br />
                            ASP.NET Core 10/Node.js<br />
                            ASP.NET 4.8/ASP/PHP 8.x  
                            <br />Free 256 bit SSL 
                        </div>
                        <button type="submit" class="insuba-btn text-center p-2 fs-5 mt-5"><a href="Contactform" className='p-5'>Contact Us</a></button>
                    </div>
                </div>
                <div className="col-md-3 text-center pb-5" data-aos="fade-up" data-aos-delay="500">
                     <div className="bg-color shadow text-white pb-5 text-center">
                        <p className="p-5 fs-3 text-white text-center">Premium Plan</p>
                        <p className="display-3 pt-5">$7.95<span className="fs-5">/mo</span></p>
                        <p className="fs-3">Unlimited Websites<br/><span className="fs-6">Unlimited Domain Pointers</span></p>
                        <div className="fs-6 space">
                            <p className="fs-5 mb-0"> Unlimited Space/Transfers </p>
                            SQL Server 2022/MySQL<br />
                            .NET 10 Hosting<br />
                            ASP.NET Core 10/Node.js<br />
                            ASP.NET 4.8/ASP/PHP 8.x  
                            <br />Free 256 bit SSL 
                        </div>
                        <button type="submit" class="insuba-btn text-center p-2 fs-5 mt-5"><a href="Contactform" className='p-5'>Contact Us</a></button>
                    </div>
                </div>
                <div className="col-md-3 text-center pb-5" data-aos="fade-up" data-aos-delay="700">
                    <div className="bg-white shadow pb-5 text-center">
                        <p className="bg-color text-white text-center mb-3 p-5 fs-3">Free Plan</p>
                        <p className="display-3 color pt-5">Free</p>
                        <p className="fs-3 pb-3">Huge Payouts!</p>
                        <div className="fs-6 space">
                            <p className="fs-5 mb-0"> Unlimited Websites</p>
                           $5 USD for Free Trial Signup <br/>60% of What We Charge!<br/>Withdraw Anytime<br/>Marketing Banners<br/>High Conversion Rates<br/>Real-Time Affiliate Panel
                        </div>
                        <button type="submit" class="insuba-btn text-center p-2 fs-5 mt-5"><a href="Contactform" className='p-5'>Contact Us</a></button>
                    </div>
                </div>
            </div>
        </div>
    </div>
  );
}
export default Mainpage;
